<template>
  <div v-if="mensagens.length">
    <div v-for="(mensagens, index) in mensagens" :key="index">
      <b-alert show variant="success" dismissible>
        <b-icon variant="success" icon="check" />
        {{ mensagens }}
      </b-alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mensagens: {
      type: Array,
      default: () => [],
    },
  },
};
</script>